"use client";

import { useState, useRef, useEffect } from "react";

export default function EmailSignup({
  autoFocus = false,
}: {
  autoFocus?: boolean;
}) {
  const [email, setEmail] = useState("");
  const [submitted] = useState(false);
  const [alreadySubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();

      if (result.success) {
        window.location.href = "/thank-you"; // Redirect after success
      } else {
        setError(result.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Server error. Please try again. Details: " + err);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <p className="text-green-600 text-lg font-semibold">
        {alreadySubscribed
          ? "🎉 You&apos;re already subscribed! Great to have you back!"
          : "🎉 Thanks for subscribing! First edition coming this Friday!"}
      </p>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col items-center gap-4 w-full max-w-md"
    >
      <input
        type="email"
        required
        placeholder="Your Best Email Address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="px-5 py-3 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-gray-800 bg-white shadow-sm disabled:bg-gray-100"
        disabled={loading}
        ref={inputRef}
      />
      <button
        type="submit"
        disabled={loading}
        className="bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800 hover:shadow-lg transition-all w-full font-semibold disabled:opacity-50"
      >
        {loading ? "Submitting..." : "Subscribe Now"}
      </button>

      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </form>
  );
}
